import { useDisclose } from "native-base";

export default useDisclose;